import { getTimeZones } from '@vvo/tzdb';

import { TimezoneData } from '@/modules/common/types/location';

import { ApiErrorCode, createApiError } from './errors';

/**
 * Retrieves and transforms timezone data for organization localization.
 * Provides timezone names, offsets, and abbreviations for proper time handling.
 * @returns Array of TimezoneData with name, value, offset, and abbreviation
 */
export const getTimezonesData = async (): Promise<TimezoneData[]> => {
  try {
    return (getTimeZones() || []).map(tz => ({
      name: tz.name,
      value: tz.name,
      offset: tz.currentTimeFormat,
      abbr: tz.abbreviation,
    }));
  } catch (error) {
    throw createApiError(ApiErrorCode.TIMEZONES_LOAD_FAILED, error);
  }
};
